import { submitKYC } from './states';

export const services = {
  submitKYC,
};
